import { Service } from "../../service/googlemaps/googlemaps";



function getDeviceCoords(device) {
    return {
        lat: parseFloat(device["latitude"]),
        lng: parseFloat(device["longitude"])
    };
}

export class GoogleMaps {

    constructor(device, mapElement, wrapperElement, setIsLoaded, setIsError) {
        this.wrapperElement = wrapperElement;
        this.setIsLoaded = setIsLoaded;
        this.setIsError = setIsError;
        this.device = device;
        this.mapElement = mapElement;
    }

    initialise(maps) {
        this.initializeGoogleMap(maps);
    }

    initializeGoogleMap(maps) {
        const self = this;
        const initialCoords = getDeviceCoords(self.device);
        self.map = new maps.Map(
            self.mapElement,
            {
                zoom: 8,
                center: initialCoords,
                mapTypeControl: false,
            }
        );
        const map = self.map;
        const submitButton = <input type="button" class="google-map-button" value="Search" />

        self.infoWindow = new google.maps.InfoWindow();

        const centerMarker = new google.maps.Marker({
            map,
            position: map.getCenter(),
        });


        submitButton.addEventListener("click", () =>
            this.geocode({ term: inputText.value })
        );
        map.addListener("center_changed", () => {
            centerMarker.setPosition(map.getCenter());
            const doCenterGeocode = () => self.geocode({ "lat": map.getCenter().lat(), "lng": map.getCenter().lng() });
            self.infoWindow.setContent(<button class="google-maps-info-button" onClick={doCenterGeocode}>Select this location</button>);
            self.infoWindow.open(map, centerMarker);
        });
        self.setIsLoaded(true);
    }

    // This function is called when the user clicks the UI button requesting
    // a geocode of a place ID.
    geocode(options) {
        const self = this;
        self.setIsError(false);
        self.setIsLoaded(false);
        return Service.geocode(options)
            .then(resp => {
                const map = self.map;
                const latLng = { lat: parseFloat(resp["lat"]), lng: parseFloat(resp["lng"]) };
                map.setZoom(11);
                map.setCenter(latLng);
                const marker = new google.maps.Marker({
                    map,
                    position: latLng,
                });

                self.infoWindow.setContent(resp["address"]);
                self.infoWindow.open(map, marker);
                return self.saveGeocodeResults(resp);
            })
            .catch((e) => {
                console.log(`geocoder failed: ${e}`);
                self.setIsError(true);
            }).finally(() => self.setIsLoaded(true));
    }

    async saveGeocodeResults(result) {
        const lat = result["lat"];
        const lng = result["lng"];
        const tz = result["timezone"];
        const culture = result["culture"];
        const locale = culture["default_locale"];
        const temperatureOption = culture["default_temperature_option"];
        const hourCycleOption = culture["default_hour_cycle_option"];
        var mapResult = {
            "location": result["location"],
            "latitude": lat,
            "longitude": lng,
            "temperature_option": temperatureOption,
            "hour_cycle_option": hourCycleOption
        };

        if (locale) {
            mapResult["locale"] = locale;
        }

        if (tz) {
            mapResult["timezone"] = tz;
        }

        const self = this;
        self.setIsLoaded(false);
        self.setIsError(false);
        return Service.updateDevice(self.device.uuid, mapResult).catch(error => {
            console.log(`device update failed: ${error}`);
            self.setIsError(true);
        }).finally(() => {
            self.setIsLoaded(true);
        });
    }
}